import { Slider, SliderField } from "../../../core/components/slider.js";
import { Button } from "../../../core/components/button.js";
import { Config } from "../../../core/config/config.js";
import React from "react";
export class PerimeterSearchControls extends React.Component<PerimeterSearchControlsProps, any>{
    render() {
        return <div style={{ width: "500px", zIndex: 1, alignSelf: "center" }}>
            <div style={{ display: "flex", padding: "10px", backgroundColor: "#fff" }}>
                <div style={{ flex: "1" }}>
                    <Slider ref={this.props.refFunction} field={this.props.sliderField} value={this.props.value} onChange={this.props.onChange}></Slider>
                </div>
                <Button handleClick={this.props.resultButtonClicked} buttonStyle={{ marginLeft: "5px" }} title={Config.translations.details} iconName={"table"} />
                <Button handleClick={this.props.closeButtonClicked} buttonStyle={{ marginLeft: "5px" }} title={Config.translations.close} iconName={"times"} />
            </div>
        </div>
    }
}

interface PerimeterSearchControlsProps {
    sliderField: SliderField;
    refFunction?(ref: any): void;
    value: number;
    onChange?(field: { model: string }, value: any, dataItem?: any): void;
    resultButtonClicked?(): any;
    closeButtonClicked?(): any;
}